import MyTasks from "./MyTasks";

const CompletedTasks = () => {
  return (
    <MyTasks
      forceView="list"
      initialStatus="done"
      lockedStatus
      title="Completed Tasks"
      hideNewTaskButton
      hideCommentIcons
      showCompletedOn
    />
  );
};

export default CompletedTasks;

